var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phone.css";
import Input from "@mui/joy/Input";
/** <b>Composant d'affichage en mode édition d'un champ de type phone</b>*/
export default function PhoneFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata, isOnStudio = _a.isOnStudio, isReport = _a.isReport;
    var t = useTranslation(["common"]).t;
    var defaultValue = useMemo(function () {
        if (!record) {
            return "";
        }
        return isReport
            ? record.value
            : record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [record, fieldName]);
    var _b = useState(""), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(defaultValue || "");
    }, [defaultValue]);
    return (_jsx("div", __assign({ className: "float-left" }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsx(PhoneInput, { country: "fr", value: value, onChange: function (value) {
                var _a;
                var newValue = value;
                setValue(newValue);
                if (onUpdate) {
                    onUpdate((_a = {}, _a[fieldName] = newValue, _a));
                }
            }, defaultErrorMessage: "Phone number not valid", inputClass: "!bg-[var(--colors-input-bg)] !border-[var(--colors-input-border)] !text-[var(--colors-input-text)]", buttonClass: "!bg-[var(--colors-input-flag-bg-sec)] !border-[var(--colors-input-border)]", dropdownClass: "!bg-[var(--colors-input-flag-bg)] !border-[var(--colors-input-border)] text-[var(--colors-input-text)] " })) })));
}
